export type SignatureStyleOption = {
  id: string;
  label: string;
  fontFamily: string;
  fontSize?: number;
  fontWeight?: number;
};

export const SIGNATURE_STYLE_OPTIONS: SignatureStyleOption[] = [
  {
    id: 'script',
    label: 'Script',
    fontFamily: '"Dancing Script", "Brush Script MT", "Lucida Handwriting", cursive',
    fontSize: 48,
  },
  {
    id: 'casual',
    label: 'Casual',
    fontFamily: '"Caveat", "Bradley Hand", "Segoe Script", cursive',
    fontSize: 42,
  },
  {
    id: 'elegant',
    label: 'Elegant',
    fontFamily: '"Great Vibes", "Lucida Calligraphy", "Lucida Handwriting", cursive',
    fontSize: 46,
  },
  {
    id: 'marker',
    label: 'Marker',
    fontFamily: '"Permanent Marker", "Segoe Script", cursive',
    fontSize: 44,
  },
  {
    id: 'handwritten',
    label: 'Handwritten',
    fontFamily: '"Patrick Hand", "Bradley Hand", cursive',
    fontSize: 40,
  },
  {
    id: 'rounded',
    label: 'Rounded',
    fontFamily: '"Handlee", "Segoe Script", cursive',
    fontSize: 42,
  },
  {
    id: 'vintage',
    label: 'Vintage',
    fontFamily: '"Allura", "Lucida Calligraphy", cursive',
    fontSize: 45,
  },
];
